// extracted by mini-css-extract-plugin
module.exports =  {"userSelect_none":"a10a3f92e9--userSelect_none--g_J_6","userSelect_auto":"a10a3f92e9--userSelect_auto--f5UVj","userSelect_all":"a10a3f92e9--userSelect_all--v9qxk"};